import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for the dashboard, specifying the path and icon using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  DASHBOARD: {
    path: `${baseRoutes.adminBaseRoutes}/dashboard`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
};

export default accessRoute;
